export { default } from './VerseEditor';